import React, { useState, useEffect } from 'react';
import './CarFilter.css';

const CarFilter = ({ onFilterChange, onSearch }) => {
  const currentYear = new Date().getFullYear();

  const [filters, setFilters] = useState({
    marca: '',
    model: '',
    transmisie: '',
    disponibilitate: '',
    anFabricatieMin: '',
    anFabricatieMax: '',
    carburant: '',
    tractiune: '',
    caroserie: '',
    kmMin: '',
    kmMax: '',
    pretMin: '',
    pretMax: ''
  });

  // ✅ Toate mărcile populare în România (importatori oficiali + populare second-hand)
  const marcaOptions = [
    'Audi', 'BMW', 'Mercedes-Benz', 'Volkswagen', 'Dacia', 'Renault', 'Ford',
    'Opel', 'Skoda', 'Peugeot', 'Citroën', 'Toyota', 'Mazda', 'Hyundai',
    'Kia', 'Honda', 'Nissan', 'Seat', 'Fiat', 'Jeep', 'Volvo', 'Suzuki',
    'Mitsubishi', 'Chevrolet', 'Alfa Romeo', 'Land Rover', 'Jaguar', 'Porsche',
    'Mini', 'Lexus', 'Subaru', 'Smart', 'Cupra', 'DS Automobiles', 'Infiniti',
    'SsangYong', 'Tesla', 'BYD', 'MG', 'Aiways', 'Great Wall', 'Chery', 'Ora'
  ];

  const transmisieOptions = ['Automată', 'Manuală', 'Semi-automată'];

  const disponibilitateOptions = ['Avem pe stoc', 'Nu este pe stoc'];

  const carburantOptions = [
    'Diesel',
    'Benzină',
    'Hibrid',
    'Benzină + GPL',
    'GPL',
    'Hybrid Plug-in',
    'Electric'
  ];

  const tractiuneOptions = ['Față', 'Spate', '4x4', 'AWD', 'FWD', 'RWD'];

  const caroserieOptions = [
    'Sedan', 'SUV', 'Hatchback', 'Break', 'Coupe', 'Cabrio',
    'Monovolum', 'Pick-up', 'Microbus'
  ];

  const generateYearOptions = () => {
    const years = [];
    for (let year = currentYear; year >= 1985; year--) {
      years.push(year);
    }
    return years;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSearchClick = () => {
    if (onSearch) {
      onSearch(filters);
    }
  };

  const handleResetClick = () => {
    const resetFilters = {
      marca: '',
      model: '',
      transmisie: '',
      disponibilitate: '',
      anFabricatieMin: '',
      anFabricatieMax: '',
      carburant: '',
      tractiune: '',
      caroserie: '',
      kmMin: '',
      kmMax: '',
      pretMin: '',
      pretMax: ''
    };
    setFilters(resetFilters);
    if (onFilterChange) {
      onFilterChange(resetFilters);
    }
  };

  useEffect(() => {
    if (onFilterChange) {
      onFilterChange(filters);
    }
  }, [filters]);

  return (
    <div className="car-filter">
      <div className="car-filter-grid">

        {/* ✅ Marca */}
        <div className="filter-group">
          <select
            name="marca"
            value={filters.marca}
            onChange={handleInputChange}
            className="filter-select"
          >
            <option value="">Marca</option>
            {marcaOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>

        {/* Model */}
        <div className="filter-group">
          <input
            type="text"
            name="model"
            placeholder="Model"
            value={filters.model}
            onChange={handleInputChange}
            className="filter-input"
          />
        </div>

        {/* Transmisie */}
        <div className="filter-group">
          <select
            name="transmisie"
            value={filters.transmisie}
            onChange={handleInputChange}
            className="filter-select"
          >
            <option value="">Transmisie</option>
            {transmisieOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>

        {/* Disponibilitate */}
        <div className="filter-group">
          <select
            name="disponibilitate"
            value={filters.disponibilitate}
            onChange={handleInputChange}
            className="filter-select"
          >
            <option value="">Disponibilitate</option>
            {disponibilitateOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>

        {/* An fabricație */}
        <div className="filter-group">
          <select
            name="anFabricatieMin"
            value={filters.anFabricatieMin}
            onChange={handleInputChange}
            className="filter-select"
          >
            <option value="">An fabricație de la</option>
            {generateYearOptions().map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>

        {/* Carburant */}
        <div className="filter-group">
          <select
            name="carburant"
            value={filters.carburant}
            onChange={handleInputChange}
            className="filter-select"
          >
            <option value="">Carburant</option>
            {carburantOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>

        {/* Tracțiune */}
        <div className="filter-group">
          <select
            name="tractiune"
            value={filters.tractiune}
            onChange={handleInputChange}
            className="filter-select"
          >
            <option value="">Tracțiune</option>
            {tractiuneOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>

        {/* Caroserie */}
        <div className="filter-group">
          <select
            name="caroserie"
            value={filters.caroserie}
            onChange={handleInputChange}
            className="filter-select"
          >
            <option value="">Caroserie</option>
            {caroserieOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>

        {/* KM și Preț */}
        <div className="filter-group">
          <input
            type="number"
            name="kmMin"
            placeholder="KM de la"
            value={filters.kmMin}
            onChange={handleInputChange}
            className="filter-input"
            min="0"
          />
        </div>

        <div className="filter-group">
          <input
            type="number"
            name="kmMax"
            placeholder="KM până la"
            value={filters.kmMax}
            onChange={handleInputChange}
            className="filter-input"
            min="0"
          />
        </div>

        <div className="filter-group">
          <input
            type="number"
            name="pretMin"
            placeholder="Preț € Min"
            value={filters.pretMin}
            onChange={handleInputChange}
            className="filter-input"
            min="0"
          />
        </div>

        <div className="filter-group">
          <input
            type="number"
            name="pretMax"
            placeholder="Preț € Max"
            value={filters.pretMax}
            onChange={handleInputChange}
            className="filter-input"
            min="0"
          />
        </div>
      </div>

      <div className="filter-actions">
        <button className="filter-btn filter-btn-search" onClick={handleSearchClick}>
          Caută
        </button>
        <button className="filter-btn filter-btn-reset" onClick={handleResetClick}>
          Resetează
        </button>
      </div>
    </div>
  );
};

export default CarFilter;
